import { useCall } from "../useCall/useCall";

const MINIMUM_INSIGHTS_DURATION_SECONDS = 5;

export function useCallDurationRule() {
  const { call } = useCall();

  const isCallDurationLow =
    (call?.durationInSecond ?? Infinity) < MINIMUM_INSIGHTS_DURATION_SECONDS;
  const hasNoTranscript = !call?.transcription;

  const shouldDisplayCallDurationScreen = isCallDurationLow && hasNoTranscript;

  return {
    shouldDisplayCallDurationScreen,
    isCallDurationLow,
  };
}
